import { Typography } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import './Pagination.scss';

interface PaginationProps {
  meta?: ListMeta;
  onChange?: (page: string) => void;
}

const AppPagination: FC<PaginationProps> = ({ meta, onChange }) => {
  const { t } = useTranslation();

  const handleChangePage = useCallback(
    (_: React.ChangeEvent<unknown>, page: number) => {
      if (page !== meta?.page) {
        onChange?.(String(page));
      }
    },
    [meta],
  );

  return (
    <div className="Pagination">
      <div className="Pagination__wrapper">
        {!!meta?.total && (
          <Typography>
            {t('pagination.dislay_pagination', {
              0: meta.total,
              1: (meta.page - 1) * meta.pageSize + 1,
              2:
                meta.page * meta.pageSize < meta.total
                  ? meta.page * meta.pageSize
                  : meta.total,
            })}
          </Typography>
        )}
        <Pagination
          page={meta?.page ?? 1}
          count={meta ? Math.ceil(meta.total / meta.pageSize) : 0}
          variant="outlined"
          shape="rounded"
          onChange={handleChangePage}
        />
      </div>
    </div>
  );
};

export default AppPagination;
